export const UPDATE_PROPS = '[asset-consolidation]UPDATE_PROPS';
export const PROCESS_HASHTOKEN = '[asset-consolidation]PROCESS_HASHTOKEN';
export const GET_ASSETS = '[asset-consolidation]GET_ASSETS';
export const CONSOLIDATE_ASSETS = '[asset-consolidation]CONSOLIDATE_ASSETS';
export const CLEAR_STORE = '[asset-landing]CLEAR_STORE';



// WEBPACK FOOTER //
// ./src/app/components/assets-consolidation/__storeFiles__/constants.js